module.exports = __webpack_public_path__ + "static/media/OBL-Reverse.d7a197b4.pdf";